import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/Atoms/Button/Button';
import { IntroPanel } from '@/components/Atoms/IntroPanel/IntroPanel';
import { Notification } from '@/components/Atoms/Notification/Notification';
import { P } from '@/components/Atoms/P/P';
import { Prose } from '@/components/Atoms/Prose/Prose';
import File from '@/components/Icons/File';
import { CenteredPage } from '@/components/Layouts/CenteredPage';
import useTranslation from '@/hooks/useTranslation';
import type { ISeriesItem } from '@/interfaces';
import { buildTrackingObject } from '@/services/Analytics/bbAnalyticsTrackers';
import { TrackingAction, TrackingCategory } from '@/services/Analytics/bnefAnalyticsSettings';
import { breakpoints } from '@/styles/media';
import styled from 'styled-components';
export const SeriesViewHeaderSection = t0 => {
  const $ = _c(17);
  const {
    series,
    firstInsightUrl
  } = t0;
  const {
    t
  } = useTranslation("series");
  let t1;
  if ($[0] !== series.isArchived || $[1] !== t) {
    t1 = series.isArchived && <Notification state="warning">{t("common:PageBanner.archiveNote")}</Notification>;
    $[0] = series.isArchived;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== series.description) {
    t2 = <P size="xlarge">{series.description}</P>;
    $[3] = series.description;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <Prose>{t1}{t2}</Prose>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== firstInsightUrl || $[9] !== t) {
    t4 = firstInsightUrl && <Button kind="primary" href={firstInsightUrl} data-analytics-tracking={buildTrackingObject(TrackingAction.FollowLink, TrackingCategory.Attachment, "Series: View Latest Report")} icon={<File />}>{t("common:Series.view_latest_report")}</Button>;
    $[8] = firstInsightUrl;
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <CenteredPage><DescriptionArea>{t3}{t4}</DescriptionArea></CenteredPage>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== series.leadImage.baseUrl || $[15] !== t5) {
    t6 = <BackgroundImageContainer $imageSrc={series.leadImage.baseUrl}>{t5}</BackgroundImageContainer>;
    $[14] = series.leadImage.baseUrl;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
interface ISeriesHeaderProps {
  series: ISeriesItem;
  firstInsightUrl?: string;
}
const BackgroundImageContainer = styled.div<{
  $imageSrc: string;
}>`
    background-image: url('${({
  $imageSrc
}) => $imageSrc}');
    background-size: cover;
    background-position: 50% 50%;
    padding: 0 var(--size-grid-half) var(--size-grid-double) var(--size-grid-unit);
    ${breakpoints.M`min-height: 30vh;`};
`;
const DescriptionArea = styled(IntroPanel)`
    width: 100%;
    ${breakpoints.M`width: 66%;`};
    ${breakpoints.XL`width: 50%;`};
    padding: 0 var(--size-grid-double) var(--size-grid-double) var(--size-grid-unit);
    > *:not(:last-child) {
        margin-bottom: var(--size-grid-double);
    }
`;